module.exports = __webpack_public_path__ + "static/media/female-2.aac654ef.svg";